export class CPlannerTask{
   public '@odata.etag': string;
   public activeChecklistItemCount;
   public appliedCategories;
   public assigneePriority: string;
   public assignments;
   public bucketId: string;
   public bucketName:string;
   public checklistItemCount;
   public  completedBy;
   public completedDateTime;
   public conversationThreadId;
   public createdBy;
   public createdDateTime:Date;
   public dueDateTime: Date;
   public hasDescription:boolean;
   public id: string;
   public percentComplete:number;
   public planId: string;
   public planeName:string;
   public previewType: string;
   public referenceCount: number;
   public startDateTime;
   public title: string;
   public col:number;
   public buckets;
   public groupId: string;
   public description: string;
   public priority: number;
    public constructor (){
        this['@odata.etag']= '';
        //this.activeChecklistItemCount;
        this.appliedCategories= {};
        this.assigneePriority= "";
        this.assignments= {};
        this.bucketId= "";
        this.bucketName="";
        this.checklistItemCount= 0;
        this.completedBy= null;
        this.completedDateTime= null;
        this.conversationThreadId= null;
        this.createdBy= {};
        // this.createdDateTime:Date;
        // dueDateTime: Date;
        this.hasDescription=false;
        this.description='';
        this.id='';
        this.percentComplete= 0;
        this.planId= "";
        this.planeName='';
        this.previewType= "";
        this.referenceCount= 0;
        this.priority=0;
        // startDateTime: null;
        this.title= "";
        // col:number;
        // buckets;
        // groupId;
    }
}
